/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { UseFormSetValue, useForm } from 'react-hook-form';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import { Input, InputProps } from '../Input/Input';
import styles from './Time.module.scss';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';

interface TimeForm {
  HH: string;
  MM: string;
  SS: string;
}

interface TimeProps extends InputProps {
  setValue?: UseFormSetValue<any>;
}

export const Time = ({
  classname,
  defaultValue,
  name,
  label,
  setValue: setExternalValue,
  errorMessage,
  register: externalRegister,
}: TimeProps) => {
  setExternalValue?.(name, null);
  const defaultValueParsed = defaultValue?.split(':');
  const [HH, setHH] = useState<string>(defaultValueParsed?.[0] || '00');
  const [MM, setMM] = useState<string>(defaultValueParsed?.[1] || '00');
  const [SS, setSS] = useState<string>(defaultValueParsed?.[2] || '00');

  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
  const { register, setFocus, setValue, getValues } = useForm<TimeForm>();

  useEffect(() => {
    setExternalValue?.(
      name,
      `${HH.padStart(2, '0')}:${MM.padStart(2, '0')}:${SS.padStart(2, '0')}`
    );
  }, [HH, MM, SS]);

  return (
    <div className={cn(styles.root, classname)}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles.time}>
        <Input
          classname={styles.HH}
          name="HH"
          tabIndex={activeTabIndex === 0 ? 0 : -1}
          register={{
            ...register('HH', {}),
          }}
          onInputCapture={(event) => {
            const { value } = event.currentTarget;

            if (value.length >= 2) {
              setFocus('MM');
              event.currentTarget.value = event.currentTarget.value.slice(0, 2);
              const timeout = setTimeout(() => {
                setValue('MM', value[2]);
                clearTimeout(timeout);
              }, 0);
            }

            setHH(event.currentTarget.value);
          }}
          onKeyDown={(event) => {
            if (event.key === '+' || event.key === '-') {
              event.preventDefault();
            }
          }}
          onFocus={(event) => {
            const { value } = event.currentTarget;

            setActiveTabIndex(0);

            if (value?.length >= 2) {
              setFocus('MM');
            }
          }}
          type="number"
          placeholder="00"
          defaultValue={defaultValueParsed?.[0] || ''}
        />
        <span onClick={() => setFocus('HH')}>hr(s)</span>
        <Input
          classname={styles.MM}
          name="MM"
          tabIndex={activeTabIndex === 1 ? 0 : -1}
          register={{ ...register('MM') }}
          onFocus={() => {
            setActiveTabIndex(1);
            if (getValues('HH')?.length < 2) {
              setFocus('HH');
            }

            if (getValues('MM')?.length >= 2) {
              setFocus('SS');
            }
          }}
          onInputCapture={(event) => {
            const { value } = event.currentTarget;

            if (Number(event.currentTarget.value) > 59) {
              event.currentTarget.value = '59';
            }

            if (Number(event.currentTarget.value) < 0) {
              event.currentTarget.value = '00';
            }

            if (value?.length >= 2) {
              setFocus('SS');
              event.currentTarget.value = event.currentTarget.value.slice(0, 2);
              const timeout = setTimeout(() => {
                setValue('SS', value[2]);
                clearTimeout(timeout);
              }, 0);
            }

            setMM(event.currentTarget.value);
          }}
          onKeyDown={(event) => {
            const { value } = event.currentTarget;

            if (event.key === '+' || event.key === '-') {
              event.preventDefault();
            }

            if (event.code === 'Backspace' && value?.length === 0) {
              setValue('HH', getValues('HH').slice(0, 1));
              const timeout = setTimeout(() => {
                setFocus('HH');
                clearTimeout(timeout);
              }, 0);
            }
          }}
          placeholder="00"
          type="number"
          defaultValue={defaultValueParsed?.[1] || ''}
        />
        <span onClick={() => setFocus('MM')}>min(s)</span>
        <Input
          classname={styles.SS}
          tabIndex={activeTabIndex === 2 ? 0 : -1}
          register={{ ...register('SS') }}
          onFocus={() => {
            setActiveTabIndex(2);

            if (getValues('MM')?.length < 2) {
              setFocus('MM');
            } else {
              setFocus('SS');
            }
          }}
          onInputCapture={(event) => {
            const { value } = event.currentTarget;

            if (Number(event.currentTarget.value) > 59) {
              event.currentTarget.value = '59';
            }

            if (Number(event.currentTarget.value) < 0) {
              event.currentTarget.value = '00';
            }

            if (value?.length >= 2) {
              event.currentTarget.value = event.currentTarget.value.slice(0, 2);
            }

            setSS(event.currentTarget.value);
          }}
          onKeyDown={(event) => {
            const { value } = event.currentTarget;

            if (event.key === '+' || event.key === '-') {
              event.preventDefault();
            }

            if (event.code === 'Backspace' && value?.length === 0) {
              setValue('MM', getValues('MM').slice(0, 1));
              const timeout = setTimeout(() => {
                setFocus('MM');
                clearTimeout(timeout);
              }, 0);
            }
          }}
          onInput={(event) => {}}
          type="number"
          placeholder="00"
          defaultValue={defaultValueParsed?.[2] || ''}
        />
        <span onClick={() => setFocus('SS')}>seg(s)</span>
      </div>
      {errorMessage && <ErrorMessage errorMessage={errorMessage} />}
    </div>
  );
};
